import React from 'react';

import PropTypes from 'prop-types';

import { combineClasses } from 'wanderu-css';

import styles from './TableOfContents.scss';

function TableOfContents(props) {
    const {
        children,
        classes: classesProp = {},
        component: Component = 'nav',
        componentProps = {},
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProp);

    return (
        <Component
            className={classes.root}
            {...otherProps}
            {...componentProps}
        >
            <ul className={classes.list}>
                {children}
            </ul>
        </Component>
    );
}

TableOfContents.propTypes = {
    /**
     * The content of the component.
     */
    children: PropTypes.node.isRequired,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
    * The component used for the root node.
    * Either a string to use a HTML element or a component.
    */
    component: PropTypes.elementType,
    /**
     * The set of component props passed down to the root component
     */
    componentProps: PropTypes.object,
};

export default TableOfContents;
